import z from "zod";

// TODO: Add actual error types for Sentry external service
const sentryErrorTypeValues = ["PLACEHOLDER_ERROR"] as const;

const sentryErrorTypeSchema = z.enum(sentryErrorTypeValues);
const SentryErrorType = sentryErrorTypeSchema.enum;
type SentryErrorType = z.infer<typeof sentryErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type SentryErrors = {
  errorType: typeof SentryErrorType.PLACEHOLDER_ERROR;
  // TODO: Add specific data fields for Sentry errors
  data: Record<string, never>;
};

export const sentryErrorDetails: Record<SentryErrorType, ErrorDetails> = {
  [SentryErrorType.PLACEHOLDER_ERROR]: {
    sentryDescription: "Sentry external service error",
  },
};
